const SWITCH_TENANT_PARAM = 'switchTenant';

// Read by `initializers/switch-tenant.js`, before the router's first
// transition — a child route's own hook runs too late, since
// `ApplicationRoute#beforeModel` already loads the organisation for whatever
// tenant is in `sessionStorage` at that point.
export function extractSwitchTenantId(search) {
  return new URLSearchParams(search).get(SWITCH_TENANT_PARAM);
}

export function urlWithoutSwitchTenantParam(href) {
  const url = new URL(href);
  url.searchParams.delete(SWITCH_TENANT_PARAM);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function appendSwitchTenantParam(url, tenantId) {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${SWITCH_TENANT_PARAM}=${encodeURIComponent(tenantId)}`;
}

// A ctrl/cmd/shift/middle-click on the dropdown's <a> is left to the browser's
// own "open in a new tab" handling -- only a plain click switches tenant in
// this tab via the in-app Ember transition.
export function isModifiedClick(event) {
  return Boolean(
    event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1,
  );
}
